if (!customElements.get('angel-sticky-buy')) {
  customElements.define('angel-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.cta = this.querySelector('button');
      this.onClick = () => {
        const original = this.main.querySelector('[id^="ProductSubmitButton-"]');
        const form = original?.form;
        if (!original || !form) return;
        if (original.disabled || original.getAttribute('aria-disabled') === 'true' || !form.querySelector('[name="id"]')?.value) {
          const target = this.main.querySelector('variant-selects input:not(:disabled), variant-selects select') || original;
          target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
          target.focus({preventScroll:true});
          return;
        }
        original.click();
      };
      this.cta.addEventListener('click',this.onClick);
      this.intersection = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.update();
      },{threshold:0});
      this.mutation = new MutationObserver(()=>this.update());
      this.mutation.observe(this.main,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      this.media = matchMedia('(max-width: 749px)');
      this.change = ()=>this.update();
      this.media.addEventListener('change',this.change);
      this.update();
    }
    update() {
      if (!this.isConnected || !this.main?.isConnected) return;
      const original = this.main.querySelector('[id^="ProductSubmitButton-"]');
      if(original !== this.original){
        this.intersection.disconnect();
        this.original = original;
        this.passed = false;
        if(original)this.intersection.observe(original);
      }
      const price = this.main.querySelector('[id^="price-"] .price__container');
      this.querySelector('[data-sticky-price]').textContent = price?.querySelector('.price-item--sale') && price.closest('.price--on-sale') ? price.querySelector('.price-item--sale').textContent.trim() : price?.querySelector('.price-item--regular')?.textContent.trim() || '';
      this.querySelector('[data-sticky-label]').textContent = original?.querySelector('span')?.textContent.trim() || '';
      this.cta.disabled = !!original?.disabled || original?.getAttribute('aria-disabled') === 'true';
      this.hidden = !this.passed || !this.media.matches || !original;
      document.documentElement.classList.toggle('angel-sticky-active',!this.hidden);
    }
    disconnectedCallback(){
      this.intersection?.disconnect();this.mutation?.disconnect();
      this.cta?.removeEventListener('click',this.onClick);
      this.media?.removeEventListener('change',this.change);
      document.documentElement?.classList.remove('angel-sticky-active');
    }
  });
}
